import * as React from 'react'
import info from '../info.json'
import {Link} from 'gatsby'
import ReCAPTCHA from "react-google-recaptcha";

import { StaticImage } from 'gatsby-plugin-image'
import { IconX, IconInfoSmall} from '@tabler/icons-react'
import { motion, animate } from 'framer-motion'
import { navigate } from 'gatsby';

export default function Form(props){

    const inputRef = React.useRef(null);
    const RECAPTCHA_V2_SITE_KEY = '6LeB8hIrAAAAAPV23iBuiOIbOILdbFxyDLfO_42v';


    const [name, setName] = React.useState('')
    const [email, setEmail] = React.useState('')
    const [currentPage, setCurrentPage] = React.useState(props.currentPage)
    const [phone, setPhone] = React.useState('')
    const [country, setCountry] = React.useState('')
    const [company, setCompany] = React.useState('')
    const [city, setCity] = React.useState('')
    const [description, setDescription] = React.useState('')
    const [quantity, setQuantity] = React.useState('')
    const [message, setMessage] = React.useState('')
    const [token, setToken] = React.useState('')

    const captchaToken = React.useRef();

    function onChangeCaptcha() {
        setToken(captchaToken.current.getValue());
      }
    

    const [error, setError] = React.useState('')
    const [submitted, setSubmitted] = React.useState(false)

    function resetStates() {
        setSubmitted(false);
        setError('');
    }
      
    function resetForm() {
        setName('');
        setEmail('');
        setMessage('');
    }

    function onSubmit(e){
        e.preventDefault();
        e.stopPropagation();
        
        resetStates();
    
        if(!token){
          setError('Please complete the google recaptcha challenge');
          return;
        }

        fetch("https://formcarry.com/s/WZgwARyyZge", {
          method: 'POST',
          headers: { 
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ currentPage, name, email, phone, country, city, description, quantity, message, 'g-recaptcha-response': token})
        })
        .then(response => response.json())
        .then(response => {
          if (response.code === 200) {
            navigate('/success');
        }
          else if(response.code === 422){
            // Field validation failed
            setError(response.message)
            
          }
          else {
            // other error from formcarry
            setError(response.message)

          }
        })
        .catch(error => {
          // request related error.
          setError(error.message ? error.message : error);

        });
    }


    const inputs = info.form.inputs.map((item)=>{

        return(
            <input 
                ref={inputRef}
                required
                type={item.type}
                className='w-full sm:w-[45%] xl:w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our' 
                placeholder={item.placeholder} 
                onTouchEnd={(e) => {
                    e.stopPropagation(); // Stop event propagation here
                    handleFocus();
              }}/>
        )
    })

    function Toggle(){
        props.setVisible((prevState)=>!prevState)
    }

        
    const variants = {
        moveX: {transform: ['translateX(100%)', 'translateX(0%)'], opacity:['0', '100'], transition: { duration: 1, type: 'spring' }},
        stop: {transform: ['translateX(0%)', 'translateX(100%)'], opacity:['100', '0'], transition: { duration: 2, type: 'spring' } }
        
    }

    const handleFocus = () => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };

    function focus(e) {
        e.stopPropagation(); // Stop event propagation here
        handleFocus();
    }

    // React.useEffect(()=>{
    //     var infoBtn = document.getElementById('info-btn')
    //     var infoData = document.getElementById('info-data')
    //     function showInfo() {
    //         // infoData.style.display = 'block'
    //     }
    //     infoBtn.addEventListener('click', showInfo())
    // })


    

    return (
        <motion.div 
            variants={variants}
            animate={props.visible ? 'moveX' : 'stop'}
            className={`form-container px-[3vw] absolute sm:bottom-0 right-0 h-full sm:h-[100vh] w-full max-w-[100vw] sm:max-w-[70vw] md:min-w-[500px] md:w-[30vw] bg-charcoal z-30 text-cream flex flex-col justify-end md:justify-center transition-opacity duration-100 opacity-0`}>
                <div className='self-center md:self-end -mr-2 mb-2 md:mb-4 cursor-pointer' onClick={Toggle} onTouchEnd={Toggle}>
                    <IconX size={40} stroke={1}/>
                </div>
                <div className='border-2 border-cream w-[100%] h-fit md:h-fit flex flex-col justify-between'>
                    <div className='flex h-[40px] md:h-[60px] border-b-2 border-cream'>
                        <div className='flex flex-1  items-center px-6 border-r-2 border-cream'>
                            <span className='text-sm md:text-base'>REQUEST FOR</span>
                        </div>
                        <div className='aspect-square h-[40px] md:h-[60px] p-2'>
                            <StaticImage className='w-full h-full max-w-[60px]' placeholder="color" src='../images/icon-rf-white.png' />
                        </div>

                    </div>
                    <div className='px-[4vw] md:px-[3vw] xl:px-[2vw] mt-4 md:mt-[3vh]'>
                        <div className='mb-[1vh]'>
                            <h5 className='uppercase text-sm md:text-base'>{props.type}</h5>
                            <h2 className='uppercase font-bold text-xl sm:text-2xl md:text- mt-[5px]'>{props.currentPage}</h2>
                        </div>


                        <form className="flex flex-col gap-[1vh] md:gap-[1.3vh] w-full" name="contact"  onSubmit={(e) => onSubmit(e)}>

                            <div class="formcarry-block">
                                <input type="text" name="$Form" value={props.currentPage}  className='hidden' />                            
                            </div>

                            <div class="formcarry-block">

                                <input className='w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our text-sm md:text-base' onChange={(e) => setName(e.target.value)} required type="text" name="name" placeholder={'Name'} ref={inputRef} onTouchEnd={(e)=>{focus(e)}} />
                            </div>

                            <div class="formcarry-block">

                            <input className='w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our text-sm md:text-md' onChange={(e) => setEmail(e.target.value)} required type="email" name="email" placeholder={'Email'}  ref={inputRef} onTouchEnd={(e)=>{focus(e)}}/>
                            </div>

                            <div class="formcarry-block">
                            <input className='w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our text-sm md:text-xl' onChange={(e) => setPhone(e.target.value)} required type="tel" name="phone" placeholder={'Phone Number'} ref={inputRef} onTouchEnd={(e)=>{focus(e)}}/>
                            </div>

                            <div className='flex gap-2'>
                                <div class="formcarry-block w-full">
                                    <input className='w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our text-sm md:text-xl' onChange={(e) => setCountry(e.target.value)} required type="text" name='$country'  placeholder={'Country'} ref={inputRef} onTouchEnd={(e)=>{focus(e)}}/>
                                </div>

                                <div class="formcarry-block w-full">
                                    <input className='w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our text-sm md:text-xl' onChange={(e) => setCity(e.target.value)} required type="text" name='$city'  placeholder={'City'} ref={inputRef} onTouchEnd={(e)=>{focus(e)}}/>
                                </div>

                            </div>
                            <div class="formcarry-block">

                                <select onChange={(e) => setDescription (e.target.value)} id="description" required name="$description" className='w-full bg-charcoal text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-out text-sm md:text-xl' ref={inputRef} onTouchEnd={(e)=>{focus(e)}}>
                                    <option value="default" selected disabled >What describes you the best</option>
                                    <option value="Wholesaler">Wholesaler</option>
                                    <option value="Event Planner">Event Planner</option>
                                    <option value="Retailer">Retailer</option>
                                </select>
                            </div>

                            <input className='w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our text-sm md:text-xl' onChange={(e) => setCompany(e.target.value)} required type="text" name="$company" placeholder={'Company'} ref={inputRef} onTouchEnd={(e)=>{focus(e)}} />

                            <div className='flex gap-4 relative'>
  
                                <div className='w-full formcarry-block'>
                                    
                                    <select onChange={(e) => setQuantity(e.target.value)} id="quantity" required name="$quantity" className='w-full h-full bg-charcoal text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-out text-sm md:text-xl' ref={inputRef} onTouchEnd={(e)=>{focus(e)}} >
                                        <option value="default" selected disabled >Quantity</option>
                                        <option value="100-500">100-500</option>
                                        <option value="500-1000">500-1000</option>
                                        <option value="More than 1000">More than 1000</option>
                                    </select>

                           
                                </div>

                                <div className='group aspect-square border border-cream/50 hover:bg-cream/10 transition-all ease-in-out pointer static' id='info-btn'>
                                    <IconInfoSmall size={25} stroke={1} className='block md:hidden'/>    
                                    <IconInfoSmall size={40} stroke={1} className='hidden md:block'/>    
                                    <div className='info absolute w-full h-full flex items-center bg-charcoal text-cream/80 top-0 left-0 leading-[20px] p-px opacity-0 invisible group-hover:visible group-hover:opacity-100 transition-opacity ease-in-out duration-200' id='info-data'>
                                        <p className='underline underline-offset-4 text-sm md:text-base'>How many stems of roses do you demand in a weekly basis</p>
                                    </div>
                                </div>
                              
                            </div>

                            <div class="formcarry-block">

                                <input className='w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our text-sm md:text-xl' onChange={(e) => setMessage(e.target.value)} required type="text" name="message" placeholder={'Message'} ref={inputRef} onTouchEnd={(e)=>{focus(e)}} />
                            </div>

                          
                            <div className="formcarry-block">
                                <ReCAPTCHA
                                    ref={captchaToken}
                                    sitekey={RECAPTCHA_V2_SITE_KEY}
                                    onChange={onChangeCaptcha}
                                />
                            </div>
                            
                            <div class="inline-flex items-center">
                                <label class="relative flex items-center rounded-full cursor-pointer" htmlFor="checkbox">
                                    <input type="checkbox"
                                    class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none border border-cream transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-900 checked:before:bg-gray-900 hover:before:opacity-10"
                                    id="checkbox" required />
                                    
                                    <span
                                    class="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor"
                                        stroke="currentColor" stroke-width="1">
                                        <path fill-rule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clip-rule="evenodd"></path>
                                    </svg>
                                    </span>
                                </label>
                                <label htmlFor="terms" className='ml-4'>Terms & Conditions</label>


                            </div> 

                            <div class="formcarry-block">
                                <input type="submit" value="SEND" className="w-full self-end pointer border duration-100 transition-bg ease-in-out hover:text-black hover:bg-white px-6 py-2" ref={inputRef} onTouchEnd={(e)=>{focus(e)}}  style={{cursor: 'pointer'}}></input>
                            </div>


                            <span className='text-xs text-cream/50'>
                                By clicking “Send” I agree to receive emails, text messages, and phone calls, which may be recorded and/or sent using automated dialing or emailing equipment or software unless I opt-out from such communications. I also agree to the 
                                <Link to="/terms-conditions" className='text-cream text-xs'> Terms of Use</Link> and <Link to="/privacy-policy" className='text-cream text-xs'>Privacy Policy</Link> linked below. I understand that my consent to be contacted is not a requirement to purchase any product or service and that I can opt out at any time. Message & data rates may apply. Message frequency varies.
                            </span>



                        </form>

                        <div></div>
                    </div>
                    
                    <div className='flex w-full justify-between py-4 px-4 items-center'>
                        <span className='uppercase font-bold align-baseline text-sm md:text-base'>Royal Flowers</span>
                        <span className='font-caslon align-baseline md:mt-[6px] text-sm md:text-md'>Made in Ecuador</span>
                    </div>
                </div>

        </motion.div>
    )
}
